import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ChatMessageContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  boxSizing: 'border-box',
  padding: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(1, 0.5),
  },
}));
